document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelectorAll('#cprModule').length > 0) {
		import('./ts/cpr-module')
			.then((module) => {
				const cprModule = new module.CprModule();
				cprModule.init();
			})
			.catch(() => {});
	}
	if (document.querySelectorAll('#CEModule').length > 0) {
		import('./ts/ce-module')
			.then((module) => {
				const searchModule = new module.SearchModule();
				searchModule.init();
			})
			.catch(() => {});
	}
	if (document.querySelectorAll('#CPBR').length > 0) {
		import('./ts/cpbr-module')
			.then((module) => {
				const cpbrModule = new module.CpbrModule();
				cpbrModule.init();
			})
			.catch(() => {});
	}
	if (document.querySelectorAll('form').length > 0) {
		import('./ts/form-validation')
			.then((module) => {
				const forms = document.querySelectorAll('form');
				forms.forEach((form) => {
					const formId = form.id;
					if (formId === '') return;
					const validator = new module.FormValidator(formId);
					validator.init();
				});
			})
			.catch(() => {});
	}
});
